import React from 'react'
import { DrawerSeeker } from "@ui-seeker/core"
import { userPayload } from "Pages/Admin/Users/@signals"
import { isEmpty } from "@ui-seeker/utils"
import { useComputed } from "@preact/signals-react"
import CreateUserDrawerContent from "Pages/Admin/Users/CreateDrawer/Content"
import UserCreateFooter from "Pages/Admin/Users/CreateDrawer/Content/Footer"


export default function CreateUserDrawer() {


	const isModalOpen = useComputed(() => !isEmpty(userPayload.value))

	if (!isModalOpen.value) return null

	return <DrawerSeeker
		title={userPayload.peek().name ? `Edit ${userPayload.peek().name}` : 'Create new User'}
		width="100%"
		variant="persistent"
		isOpen={isModalOpen.value}
		customFooter={<UserCreateFooter/>}
	>
		<CreateUserDrawerContent/>
	</DrawerSeeker>
}